import { Component, DestroyRef, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { authActions } from './store/auth/auth.actions';
import { generalActions } from './store/general/general.actions';
import { IdamService } from './services/idam.service';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CONSTANTS } from 'src/infrastructure/constants';
import { pickSupportedLanguage } from './services/language.util';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {
  private title = inject(Title);
  private transloco = inject(TranslocoService);
  private destroyRef = inject(DestroyRef);

  constructor(private store: Store, private idam: IdamService) {
    store.dispatch(authActions.checkingTokens());

    const hostNameSplitted = window.location.hostname.split('.');
    let clientCode = hostNameSplitted[0];
    if (clientCode === 'news'){
      clientCode = 'movesion';
    }
    this.store.dispatch(generalActions.loadClientInfo({ code: clientCode }));

    const savedLang = localStorage.getItem(CONSTANTS.language);
    const availableLangs = this.transloco.getAvailableLangs() as string[];
    if (savedLang && availableLangs.includes(savedLang)) {
      this.transloco.setActiveLang(savedLang);
    } else {
      const browserLangs = navigator.languages?.length
        ? navigator.languages
        : [navigator.language || this.transloco.getDefaultLang()];
      this.transloco.setActiveLang(
        pickSupportedLanguage(browserLangs, availableLangs, this.transloco.getDefaultLang())
      );
    }

    // Persisting is reserved for explicit user choices (header selector);
    // auto-detected languages must not shadow future browser-preference changes.
    this.transloco.langChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((lang) => {
        document.documentElement.lang = lang;
      });

    this.transloco
      .selectTranslate('page_title')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((title) => this.title.setTitle(title));
  }
}
